// extracted by mini-css-extract-plugin
module.exports = {"modalConfirm":"styles_modalConfirm__2bZDW","buttons":"styles_buttons__YaoXT"};